import { Box } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { StoreDetailsLayout } from '~/components/routes/stores/StoreDetailsLayout'
import { KiosksManagementPanel } from '~/components/routes/stores/config/KiosksManagementPanel'
import { STORE_TAB_PERMISSIONS } from '~/components/routes/stores/tabs'
import { useStore } from '~/components/routes/stores/useStore'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/stores/$storeId/kiosks')({
  staticData: {
    permission: STORE_TAB_PERMISSIONS.kiosks,
  },
  component: StoreKiosksTab,
  params: {
    parse: z.object({ storeId: z.coerce.number() }).parse,
  },
})
withRoutePermissions(Route)

function StoreKiosksTab() {
  const { storeId } = Route.useParams()
  const { store } = useStore(storeId)

  return (
    <StoreDetailsLayout storeId={storeId} tab="kiosks">
      <Box sx={{ marginTop: '16px' }}>
        <KiosksManagementPanel storeReference={store?.checkpointStoreRef} />
      </Box>
    </StoreDetailsLayout>
  )
}
